const StatusChart = ({ level }) => {
	return (
		<div className='status-chart'>
			<div className={`status-chart__indicator status-chart__indicator--${level}`}></div>
		</div>
	);
};

export default StatusChart;
